import moment from 'moment';
/**
 * Swaps out one of the slides on the "UPCOMING EVENTS" content block.
 */
$(document).on('click', '.load-more-button', function() {
  var $load_more = $('.load-more-hidden').first();
  if ( $load_more.length ) {
    $load_more.removeClass('load-more-hidden');
  } else {
    $(this).addClass('disabled').attr('disabled','disabled');
  }
}).on('click', '.more-information-toggle', function() {
  $(this).addClass('d-none');
  $(this).parents('.location').find('.hours,.less-information-toggle').removeClass('d-none');
}).on('click', '.less-information-toggle', function() {
  $(this).addClass('d-none');
  $(this).parents('.location').find('.hours').addClass('d-none');
  $(this).parents('.location').find('.more-information-toggle').removeClass('d-none');
});
function show_event( event, selector ) {
  var time_start_string = typeof event.dateStart === 'string'? event.dateStart: event.dateStart.date;
  var time_start = moment( time_start_string ).format( "MMMM D, YYYY" );
  if ( moment( time_start_string ) >= moment() ) {
    $(selector).find('h2 a').attr('href', event.mainUrl).text( event.title );
    $(selector).find('p').text( time_start );
    if ( event.image.length ) {
      $(selector).css({
        'background-image': "linear-gradient(to bottom, rgba(16,24,32,.3 ),rgba(16,24,32,.3 )), url(" + event.image + ")",
        "background-size" : "cover"
      });
    }
  }
}
$(document).ready(function() {
  let urlMatches = document.location.href.match( /(regions\/.+)\// );
  console.log(urlMatches);
  // This will pull in the events related to a region ONLY on the regions pages
  if (urlMatches && urlMatches.length) {

    var slug = urlMatches[1];
    var json_url = "https://calendar.ochsner.org/cal/events/" + slug + ".json";

    $('#masthead-slideshow .initial, .loading-container').remove();

    $('.promo-carousel, .region-carousel, .awards-carousel, .community-news-carousel, .in-the-news-carousel')
      .removeClass('d-none')
      .flickity({
        autoPlay: true,
        draggable: true,
        prevNextButtons: false,
        on: {
          ready: () => {
            document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
              el.setAttribute('tabindex', '-1');
            })
          },
          select: () => {
            document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
              el.removeAttribute('tabindex');
            });
            document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
              el.setAttribute('tabindex', '-1');
            })
          }
        }
      });

    $('#full-masthead-carousel, .region-quote-carousel').removeClass('d-none').flickity({
      autoPlay: true,
      draggable: true,
      prevNextButtons: true,
      on: {
        ready: () => {
          document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
            el.setAttribute('tabindex', '-1');
          })
        },
        select: () => {
          document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
            el.removeAttribute('tabindex');
          });

          document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
            el.setAttribute('tabindex', '-1');
          })
        }
      }
    });

    var upcoming_events = $.ajax({
      url: json_url,
      dataType: "jsonp",
      success: function( response ) {

        var locations = response.data;
        for ( var i = 0; i < locations.length; i++) {
          show_event( locations[i], "#event-" + (i + 1).toString() );
        }

        if ( typeof manual_events !== 'undefined' ) {
          for (var i = 0; i < manual_events.length; i++) {
            let url = manual_events[i];
            if ( url.match(/event\/\d+$/) ) {
              var jsonURL = url + "/json";
            } else {
              var jsonURL = url + ".json";
            }
            $.ajax({
              url: jsonURL,
              dataType: "jsonp",
              success: function( response ) {
                if( response.data.length ) {
                  let slideIndex = manual_events.indexOf(url) + 1;
                  show_event(response.data[0], "#event-" + slideIndex.toString());
                }
              }
            });


          }
        }

        $('.upcoming-events-carousel').removeClass('d-none').flickity({
          autoPlay: true,
          draggable: true,
          prevNextButtons: false,
          on: {
            ready: () => {
              document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
                el.setAttribute('tabindex', '-1');
              })
            },
            select: () => { 
              document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
                el.removeAttribute('tabindex');
              })

              document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
                el.setAttribute('tabindex', '-1');
              })
            }
          }
        });

      }
  });
  }
});
